var _circle, _circle2, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 30.1758,
    r: 19,
    stroke: "#0079C0",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 30.1758,
    r: 19,
    stroke: "#0079C0",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156:18535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 32,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 0.675781,
    width: 31,
    height: 32,
    fill: "#C4C4C4",
    stroke: "#0079C0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156:18535)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 30.1758,
    r: 19,
    stroke: "#0079C0",
    strokeWidth: 4
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.3b316481044b723f47abf2f08233e064.svg";
export { ForwardRef as ReactComponent };